import {
  EMPTY_BUDGET_NOTIFICATION,
  type AllocationResponse,
  type BudgetNotificationSettings,
  type BudgetRequest,
  type BudgetResponse,
  type BudgetWithIds,
} from '../../typings/budget'

type ToApiProps = {
  amount: number
  promotionId: string
  promotionName: string
  notification?: BudgetNotificationSettings
}

export class BudgetMapper {
  static toAPI({
    amount,
    promotionId,
    promotionName,
    notification,
  }: ToApiProps): BudgetRequest {
    const startDate = new Date().toISOString()
    const endDate = new Date(
      new Date().setFullYear(new Date().getFullYear() + 1000)
    ).toISOString()

    return {
      PromotionId: promotionId,
      PromotionName: promotionName,
      Amount: amount,
      NotificationThresholds: notification?.enable ? notification.thresholds : [],
      Emails: notification?.enable ? notification.emails : [],
      StartDate: startDate,
      EndDate: endDate,
    }
  }

  static fromAPI(
    budget: BudgetResponse,
    allocation?: Partial<AllocationResponse>
  ): BudgetWithIds {
    const resolvedAllocationId =
      allocation?.id ??
      budget.allocations[0].id ??
      ''

    return {
      id: budget.id,
      allocationId: resolvedAllocationId,
      amount: budget.balance.amount,
      utilized: budget.balance.amount - budget.balance.remaining,
      status: budget.status,
      notification: BudgetMapper.notificationFromApi(allocation?.notificationSettings),
    }
  }

  private static notificationFromApi(
    settings:
      | BudgetResponse['notificationSettings']
      | AllocationResponse['notificationSettings']
  ): BudgetNotificationSettings {
    if (!settings || !settings.enable) return EMPTY_BUDGET_NOTIFICATION

    return {
      enable: settings.enable,
      thresholds: settings.thresholds?.map((t) => t.value) ?? [],
      emails:
        settings.recipients
          ?.filter((r) => r.type === 'Email')
          .map((r) => r.identifier) ?? [],
    }
  }
}
